import { useState } from 'react';
import { createPortal } from 'react-dom';
import HubHelpModal from './HubHelpModal.jsx';

const BookOpenIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
  </svg>
);

/**
 * 右下固定のヘルプボタン（機能ガイド・トラブルシュート）
 */
export default function HubHelpDock() {
  const [open, setOpen] = useState(false);

  const dock = (
    <div className="hub-help-dock" aria-label="ヘルプツール">
      <button
        type="button"
        className="hub-help-dock-btn"
        onClick={() => setOpen(true)}
        title="ヘルプ・機能ガイド"
        aria-label="ヘルプ・機能ガイドを開く"
      >
        <BookOpenIcon />
      </button>
    </div>
  );

  return createPortal(
    <>
      {dock}
      <HubHelpModal isOpen={open} onClose={() => setOpen(false)} />
    </>,
    document.body
  );
}
